// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue       from 'vue'
import VueTube  from 'vue-youtube'
import App       from '@/App'
import router    from '@/router'

import store     from '@/store'
import eventHub  from '@/plugins/event-hub'
import io        from '@/plugins/vue-multichannel-scoketio'
import vueSkyway from '@/plugins/vue-skyway'

import ElementUI from 'element-ui'
import locale    from 'element-ui/lib/locale/lang/ja'
import 'element-ui/lib/theme-chalk/index.css'

import floatingWindow  from '@/components/floatingWindow'

Vue.mixin({
  methods: {
    getUniqueString (strong) {
      strong = strong || 1000
      return new Date().getTime().toString(16) + Math.floor(strong * Math.random()).toString(16)
    }
  }
})

const ws = process.env.NODE_ENV === 'development' ? `https://${location.hostname}:8888` : `https://${location.host}`
const sockets = [ws, `${ws}/canvas`, `${ws}/image`, `${ws}/object`]
Vue.use(io, sockets, store)
Vue.use(ElementUI, { locale })
Vue.use(eventHub)
Vue.use(VueTube)
Vue.use(vueSkyway)
Vue.component('floating-window', floatingWindow)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el         : '#app',
  store,
  router,
  components : { App },
  template   : '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js